import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import BackBar from '../components/BackBar';
import Footer from '../components/Footer';
import './NotFound.css';

const NotFound = () => (
  <>
    <BackBar />
    <main className="container notfound-main">
      <Compass size={40} className="notfound-icon" aria-hidden="true" />
      <h1>Page not found</h1>
      <p>This page may have moved, or the link might be out of date.</p>
      <Link to="/" className="notfound-link">Browse open jobs</Link>
    </main>
    <Footer />
  </>
);
export default NotFound;
